import { iconMapping } from "@foodpilot/foods";

export const resolveMenuIcon = (name?: string): keyof typeof iconMapping => {
    const aliases: Record<string, string> = {
        scoresindicators: "scoresIndicators",
        company: "corporate",
        menu: "hamburgerMenu",
    };
    const key = name || "menu";
    const resolved = Object.hasOwn(aliases, key) ? aliases[key] : key;

    return Object.hasOwn(iconMapping, resolved) ? (resolved as keyof typeof iconMapping) : "default";
};
